import Vue from "vue";
import dayjs from "dayjs";
import md5 from "md5";
import utils from "@/helpers/utils";

Vue.filter("displayDate", value => {
  const formattedDate = value ? dayjs(value).format("DD.MM.YYYY") : "";
  return formattedDate;
});

Vue.filter("timestamp", value => {
  const formattedDate = value ? dayjs(value).format("DD.MM.YYYY, HH:mm") : "";
  return formattedDate;
});

Vue.filter("dateWithTime", value => (value ? dayjs(value).format("DD.MM.YYYY HH:mm") : ""));

Vue.filter("avatarColor", value => `#${md5(value).slice(0, 6)}`);

Vue.filter("fullName", value => utils.getFullName(value));

Vue.filter("memberInitials", value => {
  const { firstName, lastName } = value;
  return firstName || lastName ? (firstName?.[0] || "") + (lastName?.[0] || "") : ":(";
});
